export enum ToastType {
  SUCCESS = "success",
  FAILED = "failed",
  INFO = "info",
  WARNING = "warning"
}
